module.exports = __webpack_public_path__ + "img/bocal_4_zoom_with_notes.27f05a28.jpg";